import React from 'react';
import VideoPlayer from './components/VideoPlayer';

const PostPage = () => {
  return (
    <div className="max-w-7xl mx-auto p-6">
      <section className="text-center">
        <h1 className="text-4xl font-bold animate-gradient-text mb-6">How to Post an event</h1>
        <p className="text-lg text-gray-100 mb-8 max-w-lg mx-auto break-words">
          Simply forward the event details to our WhatsApp bot.
          Watch the video below to see how it works.
        </p>
        <div className="mb-10">
          <VideoPlayer src="/videos/post.mp4" />
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="https://wa.me/784428875?text=Hi" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-green-500 text-white px-6 py-3 rounded-full shadow-md hover:bg-green-600 transition-transform duration-300 transform hover:scale-105"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
              <path d="M20.52 3.48A11.938 11.938 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.13 1.59 5.92L0 24l6.2-1.61A11.93 11.93 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.2-3.48-8.52zM12 22c-1.8 0-3.53-.47-5.06-1.37l-.36-.21-3.68.95.98-3.58-.23-.37C2.63 15.53 2 13.8 2 12c0-5.52 4.48-10 10-10 2.67 0 5.19 1.04 7.07 2.93S22 9.33 22 12c0 5.52-4.48 10-10 10z" />
              <path d="M17.45 14.37c-.27-.14-1.6-.79-1.84-.88-.25-.1-.43-.14-.6.14s-.69.88-.84 1.06c-.15.17-.31.2-.57.07-.27-.14-1.14-.42-2.18-1.33-.81-.73-1.35-1.63-1.5-1.9-.15-.27-.02-.41.12-.54.12-.12.27-.31.4-.46.13-.16.18-.27.27-.45.09-.17.05-.34-.02-.48-.07-.14-.6-1.44-.82-1.98-.21-.5-.43-.44-.6-.45l-.5-.01c-.17 0-.45.06-.68.31s-.9.88-.9 2.13c0 1.25.92 2.45 1.05 2.62.14.18 1.8 2.75 4.37 3.86.61.26 1.08.41 1.45.52.61.19 1.16.16 1.6.1.49-.07 1.6-.65 1.82-1.27.22-.61.22-1.13.16-1.23-.06-.1-.24-.15-.5-.29z" />
            </svg>
            Send Your Post on WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
};

export default PostPage;
